import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserResponseDTO } from '@app/modules/user/interfaces/user-response-dto.interface';
import { Token } from '@interfaces/core/token.interface';
import { LocalStorageHandler } from '@services/local-storage-handler.service';
import { ToastrService } from 'ngx-toastr';

import { AuthTokenSignalHandler } from '../signal-handlers/auth-token-signal-handler';
import { AuthUserAuthenticatedSignalHandler } from '../signal-handlers/auth-user-authenticated-signal-handler';

@Injectable()
export class AuthSessionDeleter {
  constructor(
    private readonly localStorageTokenHandler: LocalStorageHandler<Token>,
    private readonly localStorageUserHandler: LocalStorageHandler<UserResponseDTO>,
    private readonly authTokenSignalHandler: AuthTokenSignalHandler,
    private readonly authUserSignalHandler: AuthUserAuthenticatedSignalHandler,
    private readonly router: Router,
    private readonly toastr: ToastrService,
  ) {}

  run(manual?: boolean): void {
    this.removeToken();
    this.removeUser();
    this.router.navigate(['']);
    if (!manual) {
      this.showToastr();
    }
  }

  private removeToken() {
    this.localStorageTokenHandler.clear();
    this.authTokenSignalHandler.cleanTokens();
  }

  private removeUser() {
    this.localStorageUserHandler.clear();
    this.authUserSignalHandler.cleanUser();
  }

  private showToastr() {
    this.toastr.error('Se ha cerrado su sesión por inactividad');
  }
}
